const commons = {
    basePath: '/foods',
    singular: 'plat',
    plural: 'plats',
}

export default  commons